module.exports = __webpack_public_path__ + "static/media/points10_8.a0c9a3e7.png";